var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataUnavailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429.5 531.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.5,99.3V49.8c0-13.4-5-25.8-14.6-35.3C405.5,5,393.1,0,379.7,0h-51.1L429.5,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,132.7L296.8,14.6C287.3,5,275,0,261.5,0H49.9C36.5,0,24.1,5,14.6,14.6C5.1,24.1,0,36.4,0,49.9v431.8             c0,27.4,22.4,49.8,49.8,49.8h329.8c27.4,0,49.8-22.4,49.8-49.8V168C429.5,154.6,423.9,142.2,414.4,132.7z M337.8,383.8             c-14.4,14.4-36.9,14.4-51.2,0.9L220,318.1l-66.5,66.5c-14.4,14.4-36.9,13.5-51.2-0.9c-14.4-14.4-14.4-36.9-0.9-51.2l66.5-66.5             l-66.5-66.5c-14.4-14.4-13.5-36.9,0.9-51.2c14.4-14.4,36.9-14.4,51.2-0.9l66.5,66.5l66.5-66.5c14.4-14.4,36.9-13.5,51.2,0.9             c14.4,14.4,14.4,36.9,0.9,51.2L272.1,266l66.5,66.5C353,346.9,352.1,369.4,337.8,383.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUnavailIcon);
export default __webpack_public_path__ + "static/media/data-unavail-icon.69a0a672760f1d250b6c759eace979c7.svg";
export { ForwardRef as ReactComponent };